// extracted by mini-css-extract-plugin
export var divider = "_xg-0";